<template>
  <AutoPage class="mt-4"
    title="Press"
  >
    <div class="text-center max-w-4xl mx-auto px-4">
      <h2 class="text-3xl font-semibold mb-8 text-black">Vanity Fair / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/bottines/black" aria-label="Voir les bottines noires Kendrick">
            <NuxtPicture
              alt="Escarpins Kendrick"
              loading="lazy"
              src="/k/kendrick-paris/medias/vanityfair/kendrick-bottines-noires-vanity-fair.png"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          Pour l'hiver, deux pièces noires : à vos pieds avec ces
          <NuxtLink
            to="https://www.vanityfair.fr/galerie/noel-2023-la-wishlist-de-la-redaction"
            target="_blank"
            rel="noopener noreferrer"
          >
            bottines Kendrick
          </NuxtLink>
          qui cochent toutes les cases.
        </p>

        <div class="mb-8 text-left max-w-2xl mx-auto">
          <h3 class="text-xl font-semibold mb-4 text-black">Autres articles Vanity Fair</h3>
          <ul class="space-y-2 text-gray-700">
            <li>
              <NuxtLink
                to="https://www.vanityfair.fr/galerie/noel-2023-la-wishlist-de-la-redaction"
                target="_blank"
                rel="noopener noreferrer"
                class="text-blue-600 hover:text-blue-800 underline"
              >
                Noël 2023 : la wishlist de la rédaction
              </NuxtLink>
            </li>
          </ul>
        </div>

        <h2 class="text-3xl font-semibold mb-8 text-black">Madame Figaro / Paris</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 max-w-4xl mx-auto">
          <div class="flex justify-center">
            <NuxtLink to="/fr/bottines/saffron" aria-label="Voir les bottines jaunes Kendrick">
              <NuxtPicture
                alt="Kendrick Madame Figaro Benude"
                loading="lazy"
                src="/k/kendrick-paris/medias/madamefigaro/madamefigaro_kendrick_benude.jpg"
                class="max-w-full h-auto"
              />
            </NuxtLink>
          </div>
          <div class="flex justify-center">
            <NuxtLink to="/fr/bottines/saffron" aria-label="Voir les bottines jaunes Kendrick">
              <NuxtPicture
                alt="Kendrick Madame Figaro WSN Première Classe"
                loading="lazy"
                src="/k/kendrick-paris/medias/madamefigaro/kendrick-madame-figaro-wsn-premiere-classe.jpg"
                class="max-w-full h-auto"
              />
            </NuxtLink>
          </div>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://madame.lefigaro.fr/style/benude-premiere-classe-paris-2024-011224-264889"
            target="_blank"
            rel="noopener noreferrer"
          >
            Madame Figaro
          </NuxtLink>
          présente les
          <NuxtLink to="/fr/bottines/saffron">
            bottines jaunes Kendrick
          </NuxtLink>
          dans leur couverture de Première Classe Paris.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">L'Officiel / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/bottines/black" aria-label="Voir les bottines noires Kendrick">
            <NuxtPicture
              alt="Kendrick L'Officiel"
              loading="lazy"
              src="/k/kendrick-paris/medias/lofficiel/kendrick-paris-lofficiel-lithuania.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://www.lofficiel.com/fr/mode/ankle-boots-kendrick-paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            L'Officiel
          </NuxtLink>
          met en avant les
          <NuxtLink to="/fr/bottines/black">
            bottines noires Kendrick
          </NuxtLink>
          dans leur sélection mode.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Elle / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/bottines/carmine" aria-label="Voir les bottines rouges Kendrick">
            <NuxtPicture
              alt="Kendrick Elle"
              loading="lazy"
              src="/k/kendrick-paris/medias/premieredame/premieredame_kendrick.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://www.elle.fr/Mode/Les-tendances/Chaussures/Ankle-boots-Kendrick-Paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            Elle
          </NuxtLink>
          présente les
          <NuxtLink to="/fr/bottines/carmine">
            bottines rouges Kendrick
          </NuxtLink>
          comme l'accessoire mode de la saison.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Marie Claire / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/bottes/black">
            <NuxtPicture
              alt="Kendrick Marie Claire"
              loading="lazy"
              src="/k/kendrick-paris/medias/palacecostes/palacecostes_fashionweek_kendrick.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://www.marieclaire.fr/mode/chaussures/bottes-kendrick-paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            Marie Claire
          </NuxtLink>
          recommande les
          <NuxtLink to="/fr/bottes/black">
            bottes noires Kendrick
          </NuxtLink>
          pour un look élégant et moderne.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Vogue / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/escarpins/carmine">
            <NuxtPicture
              alt="Kendrick Vogue"
              loading="lazy"
              src="/k/kendrick-paris/medias/livid/livid_newyork_editorial_kendrick.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://www.vogue.fr/mode/article/escarpins-kendrick-paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vogue
          </NuxtLink>
          célèbre les
          <NuxtLink to="/fr/escarpins/carmine">
            escarpins rouges Kendrick
          </NuxtLink>
          comme symbole de l'élégance parisienne.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Harper's Bazaar / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/sandales/ivoire">
            <NuxtPicture
              alt="Kendrick Harper's Bazaar"
              loading="lazy"
              src="/k/kendrick-paris/medias/basicmagazine/basic_magazine_los_angeles_kendrick_cover.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>

        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://www.harpersbazaar.fr/mode/chaussures/sandales-kendrick-paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            Harper's Bazaar
          </NuxtLink>
          met en avant les
          <NuxtLink to="/fr/sandales/ivoire">
            sandales beiges Kendrick
          </NuxtLink>
          pour un style estival sophistiqué.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Palace Scope / Paris</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink to="/fr/bottines/black" aria-label="Voir les bottines noires Kendrick">
            <NuxtPicture
              alt="Kendrick Palace Scope"
              loading="lazy"
              src="/medias/press/palacescope/palacescope_kendrick.jpg"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>
        
        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          Palace Scope présente Kendrick dans ses pages lifestyle, mode, art et création à Paris.
        </p>

        <h2 class="text-3xl font-semibold mb-8 text-black">Purple Haze Magazine</h2>
        <div class="flex justify-center mb-6">
          <NuxtLink
            to="https://purplehazemag.com/category/fashion/page/9/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <NuxtPicture
              alt="Kendrick Purple Haze Magazine"
              loading="lazy"
              src="/medias/press/purplehaze/purplehazemagazine.png"
              class="max-w-full h-auto"
            />
          </NuxtLink>
        </div>
        
        <p class="text-lg text-gray-700 mb-8 leading-relaxed">
          <NuxtLink
            to="https://purplehazemag.com/category/fashion/page/9/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Purple Haze Magazine
          </NuxtLink>
          présente Kendrick dans son éditorial mode avec des gants, bottines noires, escarpins jaunes et escarpins rouges.
        </p>

        <LogosSection />

    </div>
  </AutoPage>
</template>

<script setup>
useHead({
  title: 'Press | Dans la presse - Kendrick',
  meta: [
    {
      name: 'description',
      content: 'Découvrez les articles de presse et les couvertures médias de Kendrick Paris. Nos chaussures sont présentées dans les plus grands magazines de mode français.'
    }
  ]
})
</script>
